
import axios from "axios";
import { convenios } from "../../components/generico/utils/UrlAPI";
import authService from "../login/auth.service";

class EmpresasConvenioService {

    async getEmpresasConvenio() {

        var config = {
            method: "get",
            url: convenios + "convenios/empresas",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authService.getCurrentToken(),
            },
        };


        return await axios(config);
    }

}

export default new EmpresasConvenioService();